import { render, staticRenderFns } from "./TriangleHexagon.vue?vue&type=template&id=00fb8d62&"
import script from "./TriangleHexagon.vue?vue&type=script&lang=js&"
export * from "./TriangleHexagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports